import { forEachObjIndexed, ifElse, is, map, toLower } from 'ramda'

import { createListingAlert } from '@/ports'

//Leaving type as any for now, might change it later
type payloadProps = {
  name: string
  criteria: any
  isLoggedIn?: boolean
}

export const createAlert = async (payload: payloadProps) => {
  const deepToLowerCase = (obj: any, omitProps: any[] = []) => {
    const isPlainObj = (val: any) =>
      val && typeof val === 'object' && val.constructor === Object

    forEachObjIndexed((value, key) => {
      if (omitProps.includes(key)) {
        return
      }

      if (is(String, value)) {
        obj[key] = toLower(value)
      } else if (Array.isArray(value)) {
        obj[key] = map(
          ifElse(is(String), toLower, v => deepToLowerCase(v, omitProps)),
          value
        )
      } else if (isPlainObj(value)) {
        obj[key] = deepToLowerCase(value, omitProps)
      }
    }, obj)

    return obj
  }

  const requestBody = {
    body: {
      name: payload.name,
      frequency: 'daily',
      status: 'active',
      criteria: deepToLowerCase(payload.criteria, [
        'cities',
        'state',
        'country'
      ])
    }
  }

  const { response, body }: any = await createListingAlert(requestBody)
  if (!response.ok) {
    throw Error(body.message || response.statusText)
  }

  return body
}
